import { Space, Tooltip } from 'antd';
import type React from 'react';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import styled from 'styled-components';
import { HeaderThemeLogo } from './logo/HeaderThemeLogo.tsx';
import { HeaderThemeLogoText } from './logo/HeaderThemeLogoText.tsx';

const HeaderLogoWrapperSpace = styled(Space)`
  display: flex;
  align-items: center;
  line-height: 1;
`;
export interface IHeaderLogoProps {
  logoUrl?: string;
  logoAltText?: string;
  logoTextLine1?: string;
  logoTextLine2?: string;
  logoWrapperComponent: React.ComponentType<any>;
}

/**
 * Logo principale dell'applicativo.
 */
export function HeaderLogo(props: Readonly<IHeaderLogoProps>) {
  const {
    logoUrl,
    logoAltText,
    logoTextLine1,
    logoTextLine2,
    logoWrapperComponent: Wrapper,
  } = props;

  // gestiamo la visualizzazione Mobile per ridurre lo spazio occupato orizzontalmente
  // che provoca l'allargamento dell'header e di conseguenza del layout
  // e causa lo scrool orizzontale della pagina
  const isMobile = useBreakpoint(down('sm'));
  // se eliminiamo il testo (isMobile) lo inseriamo come tooltip
  const title = (logoTextLine1 ?? '') + ' ' + (logoTextLine2 ?? '');
  const tootipTitle = isMobile && title.trim().length > 0 ? title : undefined;

  return (
    <HeaderLogoWrapperSpace size={14}>
      <Wrapper>
        <Tooltip title={tootipTitle} trigger={['click']}>
          <HeaderThemeLogo src={logoUrl} alt={logoAltText} />
        </Tooltip>
      </Wrapper>
      {!isMobile && (
        <Space direction="vertical" size={0}>
          {logoTextLine1 && (
            <HeaderThemeLogoText>{logoTextLine1}</HeaderThemeLogoText>
          )}
          {logoTextLine2 && (
            <HeaderThemeLogoText>{logoTextLine2}</HeaderThemeLogoText>
          )}
        </Space>
      )}
    </HeaderLogoWrapperSpace>
  );
}
